import { Dialog, DialogContent, Grow, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { InventoryManagement } from './inventory-management';

export const InventoryManagementDialog = ({
  inventoryDialog,
  setInventoryDialog,
  highlightOrderNumber,
}) => (
  <Dialog
    open={!!inventoryDialog.isDialogOpen}
    onClose={() =>
      // This view is read-only (inputs are always disabled), so closing on a
      // backdrop click can't discard any user changes.
      setInventoryDialog((prev) => ({
        ...prev,
        isDialogOpen: false,
      }))
    }
    TransitionComponent={Grow}
    fullWidth={true}
    maxWidth='xl'
  >
    <IconButton
      aria-label='close'
      onClick={() =>
        setInventoryDialog((prev) => ({
          ...prev,
          isDialogOpen: false,
        }))
      }
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        zIndex: 1,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
    <DialogContent>
      <InventoryManagement
        itemId={inventoryDialog.itemId}
        locationId={inventoryDialog.locationId}
        minColWidth={110}
        isInputDisabled={true}
        highlightOrderNumber={highlightOrderNumber}
      />
    </DialogContent>
  </Dialog>
);
